import PropTypes from "prop-types";
import { useContext } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import appGlobalsContext from "app/AppGlobalsContext";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag, getSeoMetaData } from "app/reducers/partnerSelector";
import { getCanonicalUrl, getHomeUrl } from "app/utils/metas/getCanonicalUrl";
import { buildBreadcrumbSchema, buildGraph } from "app/utils/metas/schemaBuilders";
import { renderJsonLd } from "app/utils/metas/JsonLd";

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.merch,
		titleFromSanity: getSeoMetaData("merch.metaTitle")(state),
		descriptionFromSanity: getSeoMetaData("merch.metaDescription")(state),
	};
};

const MerchandisingListingHeadMetadata = ({ merchandisingLabel }) => {
	const { robotsMetaTag, titleFromSanity, descriptionFromSanity } = useSelector(
		mapStateToProps,
		shallowEqual
	);

	const title = titleFromSanity || "page.title.merch";
	const description = descriptionFromSanity || "page.description.merch";

	const { brand, shop, envVars } = useContext(appGlobalsContext);

	const { pathname, search } = useLocation();

	const intl = useIntl();

	// Preview pages must not expose indexable schema (they are noindex).
	const isPreview = search.includes("preview=");

	const homeUrl = getHomeUrl({
		brand,
		shop,
		baseUrl: envVars.BASE_URL,
		proxyBasenamePrefix: envVars.PROXY_BASENAME_PREFIX,
	});

	const merchandisingUrl = getCanonicalUrl({
		brand,
		shop,
		baseUrl: envVars.BASE_URL,
		proxyBasenamePrefix: envVars.PROXY_BASENAME_PREFIX,
		pathname,
	});

	const structuredData = isPreview
		? null
		: buildGraph(
				buildBreadcrumbSchema({
					items: [
						{ name: intl.formatMessage({ id: "faq.breadcrumb.home" }), url: homeUrl },
						{ name: merchandisingLabel, url: merchandisingUrl },
					],
				})
			);

	return (
		<HeadMetadata
			description={description}
			title={title}
			titleAttributes={{
				label: merchandisingLabel,
			}}
			robotsMetaTag={robotsMetaTag}
		>
			{renderJsonLd(structuredData)}
		</HeadMetadata>
	);
};

MerchandisingListingHeadMetadata.propTypes = {
	merchandisingLabel: PropTypes.string,
};

export default MerchandisingListingHeadMetadata;
